module.exports = __webpack_public_path__ + "static/news-2-1f44e4e267d591925a127a7819fb561b.png";